module.exports = __webpack_public_path__ + "img/youshi7.cb5af971.png";